<kl-detail-filter
  (onSaveFilter)="commitSave($event)"
  (onSelectFilter)="selectFilter($event)"
  (onCommitFilter)="commitFilter()"
  (onCloseFilter)="closeFilter()"
  (onClearAll)="clearAll()"
  (onCloseAlert)="alertShow = false"
  (onDeleteFromValues)="deleteFromValues($event)"
  (onDeleteSavedFilter)="deleteSavedFilter($event)"
  [filterList]="filterList"
  [saveForm]="saveForm"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [currentFilter]="currentFilter"
  [selectedFilterValues]="selectedFilterValues"
>
  <form #filterForm="ngForm">
    <div class="filter-group" #currentAccountStatus>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountStatus.collapsed = !currentAccountStatus.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "current_account_status" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountStatus.collapsed,
              'fa-angle-down': !currentAccountStatus.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountStatus.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          #currentAccountStatusDropdown
          [options]="currentAccountStatusOptions"
          name="currentAccount_status"
          [(ngModel)]="currentAccountStatusValue"
          [style]="{ width: '90%' }"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="filter-group" #currentAccountType>
      <div
        class="filter-group-heading ui-clickable"
        (click)="currentAccountType.collapsed = !currentAccountType.collapsed"
      >
        <p class="font-weight-light">
          {{ "current_account_type" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountType.collapsed,
              'fa-angle-down': !currentAccountType.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountType.collapsed"
      >
        <p-listbox
          [multiple]="true"
          checkbox="checkbox"
          #currentAccountStatusListbox
          [options]="currentAccountTypeOptions"
          name="currentAccount_type"
          [(ngModel)]="currentAccountTypeValue"
          [style]="{ width: '90%' }"
        ></p-listbox>
      </div>
    </div>
    <div class="filter-group" #currentAccountCode>
      <div
        class="filter-group-heading ui-clickable"
        (click)="currentAccountCode.collapsed = !currentAccountCode.collapsed"
      >
        <p class="font-weight-light">
          {{ "current_account_code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountCode.collapsed,
              'fa-angle-down': !currentAccountCode.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountCode.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_code"
          #currentAccountCodeDropdown
          [(ngModel)]="currentAccountCodeExpressionValue"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountCodeValue"
              #currentAccountCodeInput
              name="currentAccount_code_input"
              class="form-control form-control-sm"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'current-account',
                    'CURRENT_ACCOUNT_CODE',
                    currentAccountList,
                    '02.01.01'
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountDescription>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountDescription.collapsed =
            !currentAccountDescription.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "current_account_description" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountDescription.collapsed,
              'fa-angle-down': !currentAccountDescription.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountDescription.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_description"
          #currentAccountDescriptionDropdown
          [(ngModel)]="currentAccountDescriptionExpressionValue"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountDescriptionValue"
              #currentAccountDescriptionInput
              name="currentAccount_Description_input"
              class="form-control form-control-sm"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'current-account',
                    'CURRENT_ACCOUNT_DESCRIPTION',
                    currentAccountList,
                    '02.01.01'
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountSpecode1>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountSpecode1.collapsed = !currentAccountSpecode1.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "current_account_special_code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountSpecode1.collapsed,
              'fa-angle-down': !currentAccountSpecode1.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountSpecode1.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_specode1"
          #currentAccountSpecodeDropdown
          [(ngModel)]="currentAccountSpecodeExpressionValue1"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountSpeCodeValue1"
              #currentAccountSpecodeInput
              name="currentAccount_specode_1_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE1',
                    currentAccountSpecodeListComponent,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountSpecode2>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountSpecode2.collapsed = !currentAccountSpecode2.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "current_account_special_code" | translate }} 2
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountSpecode2.collapsed,
              'fa-angle-down': !currentAccountSpecode2.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountSpecode2.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_specode_2"
          #currentAccountSpecodeDropdown2
          [(ngModel)]="currentAccountSpecodeExpressionValue2"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountSpeCodeValue2"
              #currentAccountSpecodeInput
              name="currentAccount_specode_2_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE2',
                    currentAccountSpecodeListComponent,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountSpecode3>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountSpecode3.collapsed = !currentAccountSpecode3.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "current_account_special_code" | translate }} 3
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountSpecode3.collapsed,
              'fa-angle-down': !currentAccountSpecode3.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountSpecode3.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_specode_3"
          #currentAccountSpecodeDropdown3
          [(ngModel)]="currentAccountSpecodeExpressionValue3"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountSpeCodeValue3"
              #currentAccountSpecodeInput
              name="currentAccount_specode_3_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE3',
                    currentAccountSpecodeListComponent,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountSpecode4>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountSpecode4.collapsed = !currentAccountSpecode4.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "current_account_special_code" | translate }} 4
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountSpecode4.collapsed,
              'fa-angle-down': !currentAccountSpecode4.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountSpecode4.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_specode_4"
          #currentAccountSpecodeDropdown4
          [(ngModel)]="currentAccountSpecodeExpressionValue4"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountSpeCodeValue4"
              #currentAccountSpecodeInput
              name="currentAccount_specode_4_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE4',
                    currentAccountSpecodeListComponent,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountUser>
      <div
        class="filter-group-heading ui-clickable"
        (click)="currentAccountUser.collapsed = !currentAccountUser.collapsed"
      >
        <p class="font-weight-light">
          {{ "recording_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountUser.collapsed,
              'fa-angle-down': !currentAccountUser.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountUser.collapsed"
      >
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [style]="{ width: '250px' }"
            [options]="currentAccountUserOptions"
            [optionLabel]="'full_name'"
            [filter]="true"
            name="currentAccount_create_user"
            [(ngModel)]="currentAccountUserValue"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountRecordDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountRecordDate.collapsed =
            !currentAccountRecordDate.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "record_date" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountRecordDate.collapsed,
              'fa-angle-down': !currentAccountRecordDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountRecordDate.collapsed"
      >
        <div class="form-group my-1">
          <label for="currentAccount_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_first_tate"
              id="currentAccount_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="currentAccount_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_last_date"
              id="currentAccount_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountLastChangedUser>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountLastChangedUser.collapsed =
            !currentAccountLastChangedUser.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "last_changed_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountLastChangedUser.collapsed,
              'fa-angle-down': !currentAccountLastChangedUser.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountLastChangedUser.collapsed"
      >
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [options]="currentAccountUserOptions"
            [optionLabel]="'full_name'"
            [filter]="true"
            name="currentAccount_change_user"
            [(ngModel)]="currentAccountLastChangedUserValue"
            [style]="{ width: '90%' }"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountLastChangedDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountLastChangedDate.collapsed =
            !currentAccountLastChangedDate.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "last_date_changed" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountLastChangedDate.collapsed,
              'fa-angle-down': !currentAccountLastChangedDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountLastChangedDate.collapsed"
      >
        <div class="form-group my-1">
          <label for="currentAccount_last_changed_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_last_changed_first_date"
              id="currentAccount_last_changed_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="currentAccount_last_changed_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_last_changed_last_date"
              id="currentAccount_last_changed_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-detail-filter>
